import { OP } from "../../constant";

// partner list
export function fetchPartnerRequest(token) {
  return {
    type: OP.PARTNER_LIST_REQUEST,
    payload: {
      token,
    },
  };
}

export function fetchPartnerReset() {
  return {
    type: OP.PARTNER_LIST_RESET,
  };
}

//add partner
export function addPartnerRequest(token, data) {
  return {
    type: OP.ADD_PARTNER_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function addPartnerReset() {
  return {
    type: OP.ADD_PARTNER_RESET,
  };
}

//view partner
export function viewPartnerRequest(token, data) {
  return {
    type: OP.VIEW_PARTNER_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function viewPartnerReset() {
  return {
    type: OP.VIEW_PARTNER_RESET,
  };
}

//edit partner
export function editPartnerRequest(token, data) {
  return {
    type: OP.EDIT_PARTNER_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function editPartnerReset() {
  return {
    type: OP.EDIT_PARTNER_RESET,
  };
}

//activate partner
export function activatePartnerRequest(token, data) {
  return {
    type: OP.ACTIVATE_PARTNER_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function activatePartnerReset() {
  return {
    type: OP.ACTIVATE_PARTNER_RESET,
  };
}

//deactivate partner
export function deactivatePartnerRequest(token, data) {
  return {
    type: OP.DEACTIVATE_PARTNER_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function deactivatePartnerReset() {
  return {
    type: OP.DEACTIVATE_PARTNER_RESET,
  };
}

// approve agent
export function approvePartnerRequest(token, data) {
  return {
    type: OP.APPROVE_PARTNER_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function approvePartnerReset() {
  return {
    type: OP.APPROVE_PARTNER_RESET,
  };
}

// reject agent
export function rejectPartnerRequest(token, data) {
  return {
    type: OP.REJECT_PARTNER_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function rejectPartnerReset() {
  return {
    type: OP.REJECT_PARTNER_RESET,
  };
}

// get active partners
export function getActivePartnersRequest(token, data) {
  return {
    type: OP.GET_ACTIVE_PARTNERS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getActivePartnersReset() {
  return {
    type: OP.GET_ACTIVE_PARTNERS_RESET,
  };
}

// get logged in partner details
export function getLoggedInPartnerDetailsRequest(token, data) {
  return {
    type: OP.GET_LOGGED_IN_PARTNER_DETAILS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getLoggedInPartnerDetailsReset() {
  return {
    type: OP.GET_LOGGED_IN_PARTNER_DETAILS_RESET,
  };
}

// upload partner photo
export function uploadPartnerPhotoRequest(token, data) {
  return {
    type: OP.UPLOAD_PARTNER_PHOTO_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function uploadPartnerPhotoReset() {
  return {
    type: OP.UPLOAD_PARTNER_PHOTO_RESET,
  };
}

// get partner agents
export function getPartnerAgentsRequest(token, data) {
  return {
    type: OP.GET_PARTNER_AGENTS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getPartnerAgentsReset() {
  return {
    type: OP.GET_PARTNER_AGENTS_RESET,
  };
}
